import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const RotateIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path
        d="M4 2V5.13219C4 5.42605 4.36724 5.55908 4.55527 5.33333C6.3854 3.2875 9.04499 2 12.0051 2C17.5251 2 22 6.47715 22 12C22 15.9582 19.7015 19.3793 16.367 21"
        stroke="currentColor"
      />
      <path
        opacity="0.4"
        d="M11.7347 22.0003C12.2016 22.0003 12.6611 21.9691 13.1111 21.9086M2.26537 8.66699C2.15297 9.06418 2.06477 9.4656 2 9.86925M2.03457 13.5383C2.10487 13.9384 2.19644 14.3345 2.30852 14.7247M3.83292 17.9966C4.07124 18.35 4.3296 18.6902 4.6071 19.0149M7.42857 21.361C7.78228 21.5634 8.15042 21.7466 8.53228 21.9086"
        stroke="currentColor"
      />
    </SvgIcon>
  )
}
